import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, bool, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type ImmovableAssetFormType = {
  readonly name: string;
  readonly immovableAssetType: string;
  readonly value: number;
  readonly isUsableForGoals?: boolean;
  readonly isCoveredByInsurance?: boolean;
  readonly isUnderFinancing?: boolean;
  readonly note?: string;
};

export const getImmovableAssetFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<ImmovableAssetFormType> = (t) => {
  return object({
    name: string().required(t(Resources.Validation.Required)),
    immovableAssetType: string().required(t(Resources.Validation.Required)),
    value: number().required(t(Resources.Validation.Required)),
    isUsableForGoals: bool(),
    isCoveredByInsurance: bool(),
    isUnderFinancing: bool(),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
